import { Icon, ListBlock, Text } from "@jds/core";

export const FormErrorLabel = (props) => {
  const { errorMsg } = props;
  return (
    <ListBlock
      prefix={<Icon ic={"IcErrorColored"} size="s" />}
      titleBlock={{
        text: (
          <Text
            appearance="body_xs"
            text={errorMsg}
            color="feedback_error_80"
          />
        ),
      }}
    ></ListBlock>
  );
};

export default FormErrorLabel;
